export default "__VITE_ASSET__0Ifoi08x__"